
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import { IMatchForm } from '@/types/match.d';
import api from '@/api/match';
import bModal from './components/bModal.vue';
import eModal from './components/eModal.vue';
import tableMixin from './tableMixin';

@Component({
  components: {
    Pagination,
    bModal,
    eModal,
  },
})
export default class MatchView extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/match/manage:add',
    icon: 'plus',
    callback: this.handleAddForm,
    log: {
      name: '赛事管理 - 新增',
      component: 'match/mange/components/bModal',
    },
  }]

  private visible: boolean = false;

  private title: string = '添加赛事';

  private form: IMatchForm = {
    title: '',
    sponsor: '',
    thumbnail: '',
    coverImage: '',
    content: '',
    quality: '',
    declarationTime: '',
    reviewTime: '',
    auditTime: '',
    endTime: '',
    coOrganizer: '',
    manageTeacher: [],
    awardNumber: 10,
  };

  private eVisible: boolean = false;

  private eTitle: string = '';

  private data: any = {};

  /**
   * @author liangyongmou
   * @desc 打开添加赛事模态框
   * @param 空
   */
  handleAddForm() {
    this.title = '添加赛事';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @desc 到开编辑模态框
   * @param {row} 本行数据
   */
  handleUpdateForm(row: any) {
    api.getBindManage(row.pid).then((res:any) => {
      // eslint-disable-next-line no-param-reassign
      row.manageTeacher = res.map((el: any) => el.id) || [];
      this.title = '编辑赛事';
      this.form = row;
      this.visible = true;
    });
  }

  handleEmployee(row: any) {
    api.getEmployee(row.pid).then((res: any) => {
      this.data = res;
      this.eVisible = true;
      this.eTitle = '参与赛事员工列表';
    });
  }

  handleUser(row: any) {
    api.getUSer(row.pid, { pageNo: 1, pageSize: 20 }).then((res: any) => {
      this.data = res;
      this.data.pid = row.pid;
      this.eVisible = true;
      this.eTitle = '参赛人员列表';
    });
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
